import React from "react";
import { FormattedFloatField } from "./FormattedFloatField.js";

export const FormattedPercentageField = (
  props: React.ComponentProps<typeof FormattedFloatField>
) => <FormattedFloatField {...props} unit={"%"} multiplier={100} />;
